'use client'

import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Box } from '@chakra-ui/react'
import { Location, ProductOpeningHoursResponse, Region } from '@leid/api-locations'
import { Manager } from '@leid/api-managers'
import { ProductAvailabilityInfo } from '@leid/api-orders'
import { GoBackLink } from 'app/components/shared/nav/GoBackLink'
import { CustomerInfo } from 'app/utils/authentication'
import { RENT_BUTTON_CLICK_EVENT } from 'app/utils/events'
import { ItemApi } from 'appTypes/items'
import { SortingInfo } from 'appTypes/mapper'
import { CartFormValues, OrderInfo, OrderItemInfo } from 'appTypes/orders'
import { AppDispatch } from 'store'
import { getOrderItemNoRequest, getOrderNoRequest } from 'store/partials/cart/cartSlice'
import RentProduct from '../../../RentProduct/RentProduct'
import { FormikConfig, FormikContextType } from 'formik'
import theme from 'styles/theme'

type Props = {
  product: ItemApi
  customerInfo: CustomerInfo
  isEditMode: boolean
  isProlonging: boolean
  order: OrderInfo | undefined
  orderItem: OrderItemInfo | undefined
  productCalendarList: ProductAvailabilityInfo
  productLocations: Location[]
  openingHours: ProductOpeningHoursResponse[]
  rentedFrom: string
  step: number | undefined
  isRerent: boolean
  regions: Region[]
  manager: Manager | undefined
  sortingInfo: SortingInfo | undefined

  formikOptions: FormikConfig<CartFormValues>
  formikConfig: FormikContextType<CartFormValues>
}

const RightColumn = (props: Props): JSX.Element => {
  const {
    product,
    isEditMode,
    isProlonging,
    customerInfo,
    order,
    orderItem,
    productCalendarList,
    productLocations,
    openingHours,
    rentedFrom,
    step,
    isRerent,
    regions,
    manager,
    sortingInfo,
    formikOptions,
    formikConfig,
  } = props

  const dispatch = useDispatch<AppDispatch>()

  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  useEffect(() => {
    const handler = () => setIsOpen(true)
    window.addEventListener(RENT_BUTTON_CLICK_EVENT, handler)

    return () => window.removeEventListener(RENT_BUTTON_CLICK_EVENT, handler)
  }, [])

  useEffect(() => {
    // TODO: Probably remove or replace at some point
    if (orderItem) {
      dispatch(getOrderItemNoRequest(orderItem))
    }

    if (order) {
      dispatch(getOrderNoRequest(order))
    }
  }, [])

  const handleClose = () => {
    setIsOpen(false)
    document.body.style.overflow = 'unset'
  }

  return (
    <Box
      marginBottom="20px"
      css={{
        '@media (max-width: 64rem)': {
          maxWidth: '100%',
          width: '100%',
          position: 'fixed',

          left: '100vw',
          top: '76px',
          transform: `translateX(${isOpen ? -100 : 0}%)`,
          // zIndex: '1400',
          zIndex: theme.token.var('zIndex.dropdown'),
          backgroundColor: 'white',
          transition: 'transform 0.3s ease-in-out',
          '& > *': {
            paddingLeft: '20px',
            paddingRight: '20px',
          },
        },
      }}
    >
      <GoBackLink display={{ base: 'flex', lg: 'none' }} onClick={handleClose} />

      <RentProduct
        product={product}
        orderInfo={order}
        orderItemInfo={orderItem}
        customerInfo={customerInfo}
        isProlonging={isProlonging}
        isEditMode={isEditMode}
        productCalendarList={productCalendarList}
        productLocations={productLocations}
        openingHours={openingHours}
        rentedFrom={rentedFrom}
        isRerent={isRerent}
        step={step}
        regions={regions}
        manager={manager}
        sortingInfo={sortingInfo}
        formikOptions={formikOptions}
        formikConfig={formikConfig}
      />
    </Box>
  )
}

export default RightColumn
